import 'bootstrap/dist/css/bootstrap.min.css'
import '../acquisition-public/styles.scss'
import 'bootstrap/js/dist/collapse'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { EnquiryPreview } from '../acquisition-public/EnquiryPreview'

const enquiryRoot = document.getElementById('acquisition-enquiry-root')
if (enquiryRoot) createRoot(enquiryRoot).render(<EnquiryPreview />)
